module.exports = __webpack_public_path__ + "img/Battery_Replacement.150e1e55.png";